import React from 'react'
import { Link } from 'react-router-dom'

const WorkWithUs = () => {
  return (
    <>
        <section className="workWith_wrap section_pt section_pb">
        <div className="container">
            <div className="row align-items-center">
                <div className="col-lg-8 col-md-12 col-12">
                    <div className="work_left">
                        <h2 className="wow fadeInLeft" data-wow-duration="1s">
                            <img src="/assets/img/all-images/hand-shake.png" alt="Handshake icon"/> <b>Work</b> With Us</h2>
                        <p className="wow fadeInLeft" data-wow-duration="2s">We’re shaping a seamless mobility network for
                            the Tricity. Partner with us for
                            collaborations that make local travel smarter and smoother.</p>
                    </div>
                </div>
                <div className="col-lg-4 col-md-12 col-12">
                    <div className="work_button wow fadeInRight" data-wow-duration="1s">
                        <Link to="/partner">Learn More</Link>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </>
  )
}

export default WorkWithUs